import { IoTriangle } from 'react-icons/io5';
import { TbTriangleInvertedFilled } from 'react-icons/tb';
import { toSpecialFixed } from '@/lib/misc/utils';
import { Button } from '@/components/ui/button';
import { BsStars } from 'react-icons/bs';
import { useLocalStorage } from 'usehooks-ts';
import { ChainId, ZERO_ADDRESS } from '@shared/utils/config/networks';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { V2Networks } from '@shared/utils/config/networkAddresses';
import { useRouter } from 'next/router';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import useGetNativeTokenData from '@/hooks/explore/useGetNativeTokenData';
import CustomDialog from '@/components/ui/customDialog';
import Image from 'next/image';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
const logos = [ChainId.BASE, ChainId.OPTIMISM, ChainId.ARBITRUM, ChainId.ETHEREUM];
export default function EthDetailsModal({
  isModalOpen,
  toggleModal,
  price,
  change,
  onTokenClick
}) {
  const [showInfo, setShowInfo] = useLocalStorage('showEthInfo', true);
  const router = useRouter();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    PKP
  } = useSession();
  const {
    nativeTokensData,
    nativeTokensDataLoading
  } = useGetNativeTokenData();
  return <CustomDialog isOpen={isModalOpen} toggleModal={toggleModal} className={'p-0'} data-sentry-element="CustomDialog" data-sentry-component="EthDetailsModal" data-sentry-source-file="EthDetailsModal.tsx">
      <div className='text-[16px]'>
        {nativeTokensDataLoading ? <p className='text-[20px]'>Loading Native Tokens...</p> : <div>
            <div className={`mb-2 rounded-xl overflow-hidden mt-8 mx-2`}>
              <div className='flex items-center w-full mb-2 p-3'>
                <div className='relative'>
                  <Image className='w-[24px] h-[24px]' src='/static/tokenlogos/eth.png' alt='eth' width={24} height={24} />
                  <Image className='w-[10px] h-[10px] absolute bottom-0 right-0' src='/static/tokenlogos/gen.png' alt='eth' width={10} height={10} />
                </div>
                <div className='w-2/5 ta-l pl-4'>
                  <p className='text-genius-cream text-[16px]'>Ethereum</p>
                  <p className='text-genius-cream/50 text-[12px]'>ETH</p>
                </div>
                <div className='flex flex-col text-right text-wrap w-[55%]'>
                  <p className='text-base/4 text-genius-cream text-right text-wrap'>
                    {Number(price)?.toFixed(2)}
                  </p>
                  <div className='flex gap-1 items-center justify-end text-right'>
                    {change >= 0 ? <div className='flex items-center text-right'>
                        <IoTriangle color='#34D399' size={12} />
                        <p className='text-[10px] text-gray-400 ml-1 text-right'>{`${toSpecialFixed(Math.abs(change * 100), 2).value}%`}</p>
                      </div> : <div className='flex items-center text-right mt-1'>
                        <TbTriangleInvertedFilled color='#FF5B5B' size={12} />
                        <p className='text-[10px] text-red-400 ml-1 text-right'>{`${toSpecialFixed(Math.abs(change * 100), 2).value}%`}</p>
                      </div>}
                  </div>
                </div>
              </div>
              <p className='text-genius-cream/50 text-[12px] ta-l m-0 px-4'>
                {showInfo ? `Very soon, Genius will enable you to spend all your ETH as one, regardless of which
      network it’s on. We call this:` : `There are multiple versions of ETH on different networks. We recommend selecting the version of the network you are trading on to keep your fees low.`}
              </p>
            </div>
            {showInfo && <div className='gradient-genius-sides p-3.5 py-2 flex items-center justify-between mt-4'>
                <div className='flex items-center'>
                  <p className='flex items-center text-genius-cream text-[16px]'>
                    <BsStars />
                    Magic Spend
                  </p>
                  <div className='bg-black ml-2 text-[10px] text-genius-cream rounded-full p-1 px-2'>
                    Coming Soon
                  </div>
                </div>
                <div className='flex items-center'>
                  <Button onClick={() => setShowInfo(false)} className='ml-2 bg-genius-blue md:hover:bg-genius-blue text-[12px]  text-genius-cream underline rounded-full'>
                    Got it
                  </Button>
                </div>
              </div>}
            <div className='mt-4 max-h-[60vh]'>
              {logos.map((network, index) => <div onClick={() => {
            const address = ZERO_ADDRESS;
            const token0 = nativeTokensData.find(token => token.token.address?.toLowerCase() === address?.toLowerCase() && token.token.networkId === network);
            console.log('stableCoinData token0', token0, address);
            const tokenItem = token0.token;
            if (onTokenClick) {
              LogToMixpanel({
                pkp: PKP,
                eventName: EVENTS.search.clickNativeToken,
                category: CATEGORIES.search,
                metaData: {
                  tokenAddress: address,
                  source: 'mobile',
                  network: network
                }
              });
              onTokenClick(tokenItem);
            } else {
              router.push(`/asset?address=${ZERO_ADDRESS}&networkId=${tokenItem?.networkId}`);
            }
          }} key={index} className='flex items-center mb-2 h-[70px] hover:bg-genius-blue px-6'>
                  <div className='relative'>
                    <Image className='w-[24px] h-[24px]' src='/static/tokenlogos/eth.png' alt='eth' width={24} height={24} />
                    <ImageWithFallback className='w-[10px] h-[10px] absolute -bottom-1 left-4' src={getNetworkLogo(network)} alt={'networkLogo'} width={10} height={10} />
                  </div>
                  <div className='pl-4'>
                    <p className='text-genius-cream text-[16px]'>Ethereum</p>
                    <p className='text-genius-cream/50 text-[12px] ta-l flex items-end space-x-2'>
                      ETH <p className='ml-1'>on {V2Networks[network].name}</p>
                    </p>
                  </div>
                  <div className='flex-1 text-right'>
                    <p className='text-genius-cream'>{Number(price)?.toFixed(2)}</p>
                    <div className='flex items-center justify-end'>
                      {change >= 0 ? <IoTriangle color='#34D399' size={12} /> : <TbTriangleInvertedFilled color='#FF5B5B' size={12} />}
                      <p className={`ml-1 text-[10px] ${change >= 0 ? 'text-gray-400' : 'text-red-400'}`}>
                        {`${toSpecialFixed(change * 100, 2).value}%`}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>}
      </div>
    </CustomDialog>;
}